import { render, staticRenderFns } from "./reportsCard2.vue?vue&type=template&id=2bfff3c4&scoped=true"
import script from "./reportsCard2.vue?vue&type=script&lang=js"
export * from "./reportsCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfff3c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfff3c4')) {
      api.createRecord('2bfff3c4', component.options)
    } else {
      api.reload('2bfff3c4', component.options)
    }
    module.hot.accept("./reportsCard2.vue?vue&type=template&id=2bfff3c4&scoped=true", function () {
      api.rerender('2bfff3c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/reportsCard2.vue"
export default component.exports